const translation = {
  ABOUT_TITLE_H5: 'Get to Know Me',
  ABOUT_TITLE_H2: 'About Me',
  EXPERIENCE_TITLE: 'Experience',
  EXPERIENCE_P: '2+ Years Working',
  CLIENT_TITLE: 'Client',
  CLIENT_P: '10 Worldwide',
  PROJECT_TITLE: 'Projects',
  PROJECT_P: '20+ Completed',
  DESCRIPTION: 'I have over 2 years of experience, I am experienced with React and Angular as a front end technologies as well as Node js and Nest js as a backend side technologies.'
};

export default translation;
